"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _field = require("@design/ui/field");
var _input = require("@design/ui/input");
var _textarea = require("@design/ui/textarea");
var _ContentContainer = _interopRequireDefault(require("../components/layout/ContentContainer"));
var _PageContext = require("../context/PageContext");
var _materialSymbols = require("@design/icons/material-symbols");
var _SavedPromptsContext = require("../context/SavedPromptsContext");
var _toast = require("../utils/toast");
var _CategoryDropdown = _interopRequireDefault(require("@common/components/CategoryDropdown"));
var _CreateCategoryModal = _interopRequireDefault(require("@common/components/CreateCategoryModal"));
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _ResourceSharePopover = require("../components/share/ResourceSharePopover");
var _PromptAttachmentsSection = _interopRequireDefault(require("../components/PromptAttachmentsSection"));
var _AuthContext = require("../context/AuthContext");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _webApi = require("../utils/web-api");
var _promptHelpers = require("../utils/prompt-helpers");
var _promptAccess = require("@common/utils/promptAccess");
var _file = require("../utils/file");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t9 in e) "default" !== _t9 && {}.hasOwnProperty.call(e, _t9) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t9)) && (i.get || i.set) ? o(f, _t9, i) : f[_t9] = e[_t9]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MAX_PROMPT_ATTACHMENTS = 10;
function derivePromptPageMode(prompt, currentUserId) {
  if (!prompt.id) {
    return {
      kind: "create",
      type: prompt.type
    };
  }
  if ((0, _promptHelpers.isUserPrompt)(prompt)) {
    return (0, _promptAccess.canEditPrompt)(prompt, currentUserId) ? {
      kind: "edit",
      prompt: prompt
    } : {
      kind: "view",
      prompt: prompt
    };
  }
  return {
    kind: "managed",
    prompt: prompt
  };
}
var PromptPage = function PromptPage() {
  var _user$hasManagePrompt, _mode$prompt$access$c, _mode$prompt$access;
  var _usePage = (0, _PageContext.usePage)(),
    pageParams = _usePage.pageParams,
    showPage = _usePage.showPage;
  var navPrompt = pageParams.prompt;
  var _useSavedPrompts = (0, _SavedPromptsContext.useSavedPrompts)(),
    createPrompt = _useSavedPrompts.createPrompt,
    updatePrompt = _useSavedPrompts.updatePrompt,
    promptsByType = _useSavedPrompts.promptsByType;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var canManagePrompts = (_user$hasManagePrompt = user === null || user === void 0 ? void 0 : user.hasManagePromptsPermission) !== null && _user$hasManagePrompt !== void 0 ? _user$hasManagePrompt : false;
  var pageMode = navPrompt ? derivePromptPageMode(navPrompt, user === null || user === void 0 ? void 0 : user.userId) : null;
  var _useState = (0, _react.useState)((navPrompt === null || navPrompt === void 0 ? void 0 : navPrompt.name) || ""),
    _useState2 = _slicedToArray(_useState, 2),
    title = _useState2[0],
    setTitle = _useState2[1];
  var _useState3 = (0, _react.useState)((navPrompt === null || navPrompt === void 0 ? void 0 : navPrompt.description) || ""),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = (0, _react.useState)((navPrompt === null || navPrompt === void 0 ? void 0 : navPrompt.content) || ""),
    _useState6 = _slicedToArray(_useState5, 2),
    content = _useState6[0],
    setContent = _useState6[1];
  var _useState7 = (0, _react.useState)((navPrompt === null || navPrompt === void 0 ? void 0 : navPrompt.path) || ""),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedPath = _useState8[0],
    setSelectedPath = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showCreateCategoryModal = _useState0[0],
    setShowCreateCategoryModal = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isSaving = _useState10[0],
    setIsSaving = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showDeleteDialog = _useState12[0],
    setShowDeleteDialog = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showPublishDialog = _useState14[0],
    setShowPublishDialog = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isShareOpen = _useState16[0],
    setIsShareOpen = _useState16[1];
  var shareButtonRef = (0, _react.useRef)(null);
  var fieldId = (0, _react.useId)();
  var isCreateMode = (pageMode === null || pageMode === void 0 ? void 0 : pageMode.kind) === "create";
  var editPromptId = (pageMode === null || pageMode === void 0 ? void 0 : pageMode.kind) === "edit" ? pageMode.prompt.id : undefined;
  var persistedPromptId = (pageMode === null || pageMode === void 0 ? void 0 : pageMode.kind) === "edit" || (pageMode === null || pageMode === void 0 ? void 0 : pageMode.kind) === "view" ? pageMode.prompt.id : undefined;
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    savedAttachments = _useState18[0],
    setSavedAttachments = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    stagedFiles = _useState20[0],
    setStagedFiles = _useState20[1];
  var _useState21 = (0, _react.useState)(persistedPromptId !== undefined),
    _useState22 = _slicedToArray(_useState21, 2),
    attachmentsLoading = _useState22[0],
    setAttachmentsLoading = _useState22[1];
  var _useState23 = (0, _react.useState)(new Set()),
    _useState24 = _slicedToArray(_useState23, 2),
    busyAttachmentKeys = _useState24[0],
    setBusyAttachmentKeys = _useState24[1];
  // Set the moment a local add/remove lands while the initial fetch is still in
  // flight, so its resolution doesn't clobber a state the user has since edited.
  var hasLocalAttachmentChangeRef = (0, _react.useRef)(false);
  var authHeaderRef = (0, _react.useRef)(authHeader);
  authHeaderRef.current = authHeader;
  // A boolean, not the raw token, is the effect dep: it flips false->true once
  // when auth first resolves (retrying a mount where authHeader wasn't ready
  // yet) but stays true across later token rotations, so refresh never re-fetches.
  var isAuthReady = !!authHeader;
  (0, _react.useEffect)(function () {
    if (!persistedPromptId || !isAuthReady) return;
    var cancelled = false;
    hasLocalAttachmentChangeRef.current = false;
    setAttachmentsLoading(true);
    (0, _webApi.getPromptAttachments)(authHeaderRef.current, persistedPromptId).then(function (rows) {
      if (cancelled || hasLocalAttachmentChangeRef.current) return;
      setSavedAttachments(rows);
    }).catch(function (err) {
      console.error("Failed to load prompt attachments:", err);
      if (!cancelled) (0, _toast.toastError)("Failed to load attachments");
    }).finally(function () {
      if (!cancelled) setAttachmentsLoading(false);
    });
    return function () {
      cancelled = true;
    };
  }, [persistedPromptId, isAuthReady]);
  var attachmentRows = persistedPromptId ? savedAttachments.map(function (a) {
    return {
      key: a.id,
      id: a.id,
      fileName: a.fileName,
      busy: busyAttachmentKeys.has(a.id)
    };
  }) : stagedFiles.map(function (f, i) {
    return {
      key: "".concat((0, _file.normalizeFileName)(f.name), "-").concat(i),
      fileName: f.name
    };
  });
  var attachmentCount = attachmentRows.length;
  var handleAddAttachments = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(files) {
      var supported, unsupported, names, existingNames, deduped, _iterator, _step, file, normalized, _loop, _i, _deduped, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            supported = files.filter(function (f) {
              return (0, _file.isAllowedAttachmentExtension)(f.name);
            });
            unsupported = files.filter(function (f) {
              return !(0, _file.isAllowedAttachmentExtension)(f.name);
            });
            if (unsupported.length > 0) {
              names = unsupported.map(function (f) {
                return f.name;
              }).join(", ");
              (0, _toast.toastError)("Unsupported file type: ".concat(names, ". Allowed: ").concat(_file.ALLOWED_ATTACHMENT_EXTENSIONS_LABEL, "."));
            }
            if (!(supported.length === 0)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            existingNames = new Set(attachmentRows.map(function (r) {
              return (0, _file.normalizeFileName)(r.fileName);
            }));
            deduped = [];
            _iterator = _createForOfIteratorHelper(supported);
            _context2.p = 2;
            _iterator.s();
          case 3:
            if ((_step = _iterator.n()).done) {
              _context2.n = 6;
              break;
            }
            file = _step.value;
            normalized = (0, _file.normalizeFileName)(file.name);
            if (!existingNames.has(normalized)) {
              _context2.n = 4;
              break;
            }
            (0, _toast.toastWarning)("Already attached: ".concat(file.name));
            return _context2.a(3, 5);
          case 4:
            existingNames.add(normalized);
            deduped.push(file);
          case 5:
            _context2.n = 3;
            break;
          case 6:
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t2 = _context2.v;
            _iterator.e(_t2);
          case 8:
            _context2.p = 8;
            _iterator.f();
            return _context2.f(8);
          case 9:
            if (!(deduped.length === 0)) {
              _context2.n = 10;
              break;
            }
            return _context2.a(2);
          case 10:
            if (!(attachmentCount + deduped.length > MAX_PROMPT_ATTACHMENTS)) {
              _context2.n = 11;
              break;
            }
            (0, _toast.toastError)("A prompt can have at most ".concat(MAX_PROMPT_ATTACHMENTS, " files"));
            return _context2.a(2);
          case 11:
            if (!isCreateMode) {
              _context2.n = 12;
              break;
            }
            setStagedFiles(function (prev) {
              return [].concat(_toConsumableArray(prev), deduped);
            });
            return _context2.a(2);
          case 12:
            if (!(!editPromptId || !authHeader)) {
              _context2.n = 13;
              break;
            }
            return _context2.a(2);
          case 13:
            _loop = /*#__PURE__*/_regenerator().m(function _loop() {
              var file, fileBase64, attachment, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    file = _deduped[_i];
                    _context.p = 1;
                    _context.n = 2;
                    return (0, _file.readFileAsBase64)(file);
                  case 2:
                    fileBase64 = _context.v;
                    _context.n = 3;
                    return (0, _webApi.createPromptAttachment)(authHeader, editPromptId, {
                      fileName: file.name,
                      fileBase64: fileBase64
                    });
                  case 3:
                    attachment = _context.v;
                    hasLocalAttachmentChangeRef.current = true;
                    setSavedAttachments(function (prev) {
                      return [].concat(_toConsumableArray(prev), [attachment]);
                    });
                    _context.n = 5;
                    break;
                  case 4:
                    _context.p = 4;
                    _t = _context.v;
                    console.error("Failed to upload attachment:", _t);
                    sendError(_t, {
                      component: "PromptPage",
                      action: "create_attachment"
                    });
                    (0, _toast.toastError)("Failed to attach ".concat(file.name));
                  case 5:
                    return _context.a(2);
                }
              }, _loop, null, [[1, 4]]);
            });
            _i = 0, _deduped = deduped;
          case 14:
            if (!(_i < _deduped.length)) {
              _context2.n = 16;
              break;
            }
            return _context2.d(_regeneratorValues(_loop()), 15);
          case 15:
            _i++;
            _context2.n = 14;
            break;
          case 16:
            return _context2.a(2);
        }
      }, _callee, null, [[2, 7, 8, 9]]);
    }));
    return function handleAddAttachments(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleRemoveAttachment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
      var _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!isCreateMode) {
              _context3.n = 1;
              break;
            }
            setStagedFiles(function (prev) {
              return prev.filter(function (f) {
                return (0, _file.normalizeFileName)(f.name) !== (0, _file.normalizeFileName)(row.fileName);
              });
            });
            return _context3.a(2);
          case 1:
            if (!(!row.id || !editPromptId || !authHeader)) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2);
          case 2:
            setBusyAttachmentKeys(function (prev) {
              return new Set(prev).add(row.id);
            });
            _context3.p = 3;
            _context3.n = 4;
            return (0, _webApi.deletePromptAttachment)(authHeader, editPromptId, row.id);
          case 4:
            hasLocalAttachmentChangeRef.current = true;
            setSavedAttachments(function (prev) {
              return prev.filter(function (a) {
                return a.id !== row.id;
              });
            });
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t3 = _context3.v;
            console.error("Failed to remove attachment:", _t3);
            sendError(_t3, {
              component: "PromptPage",
              action: "delete_attachment"
            });
            (0, _toast.toastError)("Failed to remove ".concat(row.fileName));
          case 6:
            _context3.p = 6;
            setBusyAttachmentKeys(function (prev) {
              var next = new Set(prev);
              next.delete(row.id);
              return next;
            });
            return _context3.f(6);
          case 7:
            return _context3.a(2);
        }
      }, _callee2, null, [[3, 5, 6, 7]]);
    }));
    return function handleRemoveAttachment(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var existingPaths = (0, _react.useMemo)(function () {
    return Object.values(promptsByType).flat().map(function (p) {
      return p.path;
    }).filter(Boolean);
  }, [promptsByType]);
  if (!navPrompt || !pageMode) {
    return null;
  }
  var mode = pageMode;
  var modeType = mode.kind === "create" ? mode.type : mode.prompt.type;
  var isSkill = modeType === "skill";
  var entityLabel = _SavedPromptsContext.PROMPT_TYPE_LABELS[modeType];
  var backTab = isSkill ? "skills" : "prompts";
  var readOnly = mode.kind === "managed" || mode.kind === "view";
  var uploadStagedAttachments = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(promptId) {
      var _iterator2, _step2, file, fileBase64, _t4, _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (!(!authHeader || stagedFiles.length === 0)) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            _iterator2 = _createForOfIteratorHelper(stagedFiles);
            _context4.p = 2;
            _iterator2.s();
          case 3:
            if ((_step2 = _iterator2.n()).done) {
              _context4.n = 9;
              break;
            }
            file = _step2.value;
            _context4.p = 4;
            _context4.n = 5;
            return (0, _file.readFileAsBase64)(file);
          case 5:
            fileBase64 = _context4.v;
            _context4.n = 6;
            return (0, _webApi.createPromptAttachment)(authHeader, promptId, {
              fileName: file.name,
              fileBase64: fileBase64
            });
          case 6:
            _context4.n = 8;
            break;
          case 7:
            _context4.p = 7;
            _t4 = _context4.v;
            console.error("Failed to upload staged attachment:", _t4);
            sendError(_t4, {
              component: "PromptPage",
              action: "create_attachment"
            });
            (0, _toast.toastError)("Failed to attach ".concat(file.name));
          case 8:
            _context4.n = 3;
            break;
          case 9:
            _context4.n = 11;
            break;
          case 10:
            _context4.p = 10;
            _t5 = _context4.v;
            _iterator2.e(_t5);
          case 11:
            _context4.p = 11;
            _iterator2.f();
            return _context4.f(11);
          case 12:
            return _context4.a(2);
        }
      }, _callee3, null, [[4, 7], [2, 10, 11, 12]]);
    }));
    return function uploadStagedAttachments(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleSave = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var promptData, newPrompt, _t6;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!(!title.trim() || !content.trim())) {
              _context5.n = 1;
              break;
            }
            (0, _toast.toastError)("Title and content are required");
            return _context5.a(2);
          case 1:
            setIsSaving(true);
            _context5.p = 2;
            promptData = _objectSpread({
              name: title,
              content: content,
              type: modeType,
              path: selectedPath
            }, isSkill && {
              description: description || null
            });
            if (!(mode.kind === "edit")) {
              _context5.n = 4;
              break;
            }
            _context5.n = 3;
            return updatePrompt(mode.prompt.id, modeType, promptData);
          case 3:
            Object.assign(mode.prompt, promptData);
            _context5.n = 8;
            break;
          case 4:
            if (!(mode.kind === "create")) {
              _context5.n = 8;
              break;
            }
            _context5.n = 5;
            return createPrompt(modeType, promptData);
          case 5:
            newPrompt = _context5.v;
            if (!(newPrompt !== null && newPrompt !== void 0 && newPrompt.id && authHeader)) {
              _context5.n = 7;
              break;
            }
            _context5.n = 6;
            return uploadStagedAttachments(newPrompt.id);
          case 6:
            _context5.n = 8;
            break;
          case 7:
            if (stagedFiles.length > 0) {
              (0, _toast.toastWarning)("\"".concat(title, "\" was saved, but its attachments could not be uploaded"));
            }
          case 8:
            showPage(_PageContext.PAGES.libraryPage, {
              activeTab: backTab
            });
            _context5.n = 10;
            break;
          case 9:
            _context5.p = 9;
            _t6 = _context5.v;
            console.error("Failed to save prompt:", _t6);
            (0, _toast.toastError)("Failed to save ".concat(entityLabel.toLowerCase()));
          case 10:
            _context5.p = 10;
            setIsSaving(false);
            return _context5.f(10);
          case 11:
            return _context5.a(2);
        }
      }, _callee4, null, [[2, 9, 10, 11]]);
    }));
    return function handleSave() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleShareClick = function handleShareClick() {
    setIsShareOpen(true);
  };
  var handleDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _t7;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            setShowDeleteDialog(false);
            if (authHeader) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            _context6.p = 1;
            if (!(mode.kind === "edit")) {
              _context6.n = 2;
              break;
            }
            _context6.n = 2;
            return (0, _webApi.deleteUserPrompt)(authHeader, mode.prompt.id);
          case 2:
            showPage(_PageContext.PAGES.libraryPage, {
              activeTab: backTab
            });
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t7 = _context6.v;
            console.error("Failed to delete prompt:", _t7);
            sendError(_t7, {
              component: "PromptPage",
              action: "delete_prompt"
            });
            (0, _toast.toastError)("Failed to delete prompt");
          case 4:
            return _context6.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function handleDelete() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handlePublish = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _t8;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            setShowPublishDialog(false);
            if (!(mode.kind !== "edit" || !authHeader)) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            _context7.p = 1;
            _context7.n = 2;
            return (0, _webApi.publishUserPrompt)(authHeader, mode.prompt.id);
          case 2:
            (0, _toast.toastSuccess)("\"".concat(mode.prompt.name, "\" published as managed prompt"));
            showPage(_PageContext.PAGES.libraryPage, {
              activeTab: backTab
            });
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t8 = _context7.v;
            console.error("Failed to publish prompt:", _t8);
            sendError(_t8, {
              component: "PromptPage",
              action: "publish_prompt"
            });
            (0, _toast.toastError)("Failed to publish prompt");
          case 4:
            return _context7.a(2);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function handlePublish() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleCreateCategory = function handleCreateCategory(newPath) {
    setSelectedPath(newPath);
    setShowCreateCategoryModal(false);
  };
  var heading = mode.kind === "create" ? "Create ".concat(entityLabel) : readOnly ? "View ".concat(entityLabel) : "Edit ".concat(entityLabel);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
    className: "flex flex-col items-start p-0 bg-white h-full",
    "data-sentry-element": "ContentContainer",
    "data-sentry-component": "PromptPage",
    "data-sentry-source-file": "PromptPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-1 flex flex-col items-start px-3 py-4 gap-5 w-full overflow-y-auto",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-3 w-full",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
          onClick: function onClick() {
            return showPage(_PageContext.PAGES.libraryPage, {
              activeTab: backTab
            });
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
            width: 20,
            height: 20,
            className: "text-[#212528]",
            "data-sentry-element": "ArrowBackIcon",
            "data-sentry-source-file": "PromptPage.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "flex-1 text-[16px] font-semibold text-[#212528]",
          children: heading
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-1",
          children: [mode.kind === "edit" && ((_mode$prompt$access$c = (_mode$prompt$access = mode.prompt.access) === null || _mode$prompt$access === void 0 ? void 0 : _mode$prompt$access.canManageShares) !== null && _mode$prompt$access$c !== void 0 ? _mode$prompt$access$c : false) && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            ref: shareButtonRef,
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
            title: "Share",
            onClick: handleShareClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
              width: 18,
              height: 18,
              className: "text-[#6B7280]"
            })
          }), mode.kind === "edit" && canManagePrompts && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
            title: "Publish as Managed",
            onClick: function onClick() {
              return setShowPublishDialog(true);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UploadIcon, {
              width: 18,
              height: 18,
              className: "text-[#6B7280]"
            })
          }), mode.kind === "edit" && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-[#FEE4E2] cursor-pointer bg-transparent border-none",
            title: "Delete",
            onClick: function onClick() {
              return setShowDeleteDialog(true);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
              width: 18,
              height: 18,
              className: "text-[#6B7280]"
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-start gap-5 w-full",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "PromptPage.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldId, "-name"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "PromptPage.tsx",
            children: "Name"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
            id: "".concat(fieldId, "-name"),
            type: "text",
            value: title,
            onChange: function onChange(e) {
              return setTitle(e.target.value);
            },
            placeholder: "Enter prompt name",
            disabled: readOnly,
            "data-sentry-element": "Input",
            "data-sentry-source-file": "PromptPage.tsx"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "PromptPage.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            id: "".concat(fieldId, "-category-label"),
            htmlFor: "".concat(fieldId, "-category"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "PromptPage.tsx",
            children: "Category"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryDropdown.default, {
            id: "".concat(fieldId, "-category"),
            labelId: "".concat(fieldId, "-category-label"),
            existingPaths: existingPaths,
            selectedPath: selectedPath,
            onSelectPath: setSelectedPath,
            onOpenCreateModal: function onOpenCreateModal() {
              return setShowCreateCategoryModal(true);
            },
            "data-sentry-element": "CategoryDropdown",
            "data-sentry-source-file": "PromptPage.tsx"
          })]
        }), isSkill && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldId, "-description"),
            children: "Description"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
            id: "".concat(fieldId, "-description"),
            type: "text",
            value: description,
            onChange: function onChange(e) {
              return setDescription(e.target.value);
            },
            placeholder: "Short description of what this skill does",
            disabled: readOnly
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "PromptPage.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldId, "-content"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "PromptPage.tsx",
            children: "Prompt content"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
            id: "".concat(fieldId, "-content"),
            rows: 6,
            value: content,
            onChange: function onChange(e) {
              return setContent(e.target.value);
            },
            placeholder: isSkill ? "Type in your skill instructions" : "Type in your prompt",
            disabled: readOnly,
            "data-sentry-element": "Textarea",
            "data-sentry-source-file": "PromptPage.tsx"
          })]
        }), mode.kind !== "managed" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromptAttachmentsSection.default, {
          attachments: attachmentRows,
          onAddFiles: handleAddAttachments,
          onRemove: handleRemoveAttachment,
          loading: attachmentsLoading,
          maxReached: attachmentCount >= MAX_PROMPT_ATTACHMENTS,
          maxCount: MAX_PROMPT_ATTACHMENTS,
          readOnly: readOnly
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-shrink-0 flex items-center justify-end gap-2 w-full px-3 py-2.5 bg-white border-t border-[#E4E7EC]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: function onClick() {
          return showPage(_PageContext.PAGES.libraryPage, {
            activeTab: backTab
          });
        },
        className: "flex justify-center items-center h-[36px] px-[11.25px] py-[6.75px] border border-[#D4D3D0] rounded text-[14px] font-medium text-[#3D3D3D] bg-transparent cursor-pointer hover:bg-[#F8F6F3]",
        children: readOnly ? "Back" : "Cancel"
      }), !readOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleSave,
        disabled: !title.trim() || !content.trim() || isSaving,
        className: "flex justify-center items-center h-[36px] px-[11.25px] py-[6.75px] gap-[2.25px] rounded text-[14px] font-medium text-white border-none cursor-pointer ".concat(!title.trim() || !content.trim() || isSaving ? "bg-[#B0AFAD] cursor-not-allowed" : "bg-primary hover:bg-background-primary-hover"),
        children: isSaving ? "Saving..." : "Save"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CreateCategoryModal.default, {
      isOpen: showCreateCategoryModal,
      existingPaths: existingPaths,
      onCreateCategory: handleCreateCategory,
      onClose: function onClose() {
        return setShowCreateCategoryModal(false);
      },
      "data-sentry-element": "CreateCategoryModal",
      "data-sentry-source-file": "PromptPage.tsx"
    }), showDeleteDialog && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Confirm delete",
      message: "Are you sure you want to delete \"".concat(navPrompt.name, "\"?"),
      confirmLabel: "Delete",
      onConfirm: handleDelete,
      onCancel: function onCancel() {
        return setShowDeleteDialog(false);
      }
    }), showPublishDialog && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "primary",
      title: "Publish as managed",
      message: "Are you sure you want to publish \"".concat(navPrompt.name, "\" as a managed prompt? It will become an organization-level prompt and the original user prompt will be removed."),
      confirmLabel: "Publish",
      onConfirm: handlePublish,
      onCancel: function onCancel() {
        return setShowPublishDialog(false);
      }
    }), isShareOpen && shareButtonRef.current && mode.kind === "edit" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResourceSharePopover.ResourceSharePopover, {
      resourceKind: "prompt",
      resourceId: mode.prompt.id,
      resourceName: mode.prompt.name,
      anchorEl: shareButtonRef.current,
      access: mode.prompt.access,
      onClose: function onClose() {
        return setIsShareOpen(false);
      }
    })]
  });
};
var _default = exports.default = PromptPage;